import MobileDetect from 'mobile-detect';

export default new MobileDetect(navigator.userAgent);



// WEBPACK FOOTER //
// ./lib/js/modules/deviceDetect.js